import React, { useState } from "react";

const CodeCopyButton: React.FC = () => {
    const [copyIcon, setCopyIcon] = useState<string>("content_copy");

    // This click handler uses the button's DOM node to find the next <code> element.
    const handleCopy = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        // Get the button's DOM element from the event.
        const button = event.currentTarget;

        // Find nearest pre container.
        const preContainer = button.closest("pre");
        if (!preContainer) {
            console.warn("Could not find the parent container.");
            return;
        }

        // Find the code element.
        const codeElement = preContainer.querySelector("code");
        if (!codeElement) {
            console.warn("Could not find a code element within the parent container.");
            return;
        }

        const codeText = codeElement.textContent || "";

        // Use the Clipboard API to copy the text.
        navigator.clipboard
            .writeText(codeText)
            .then(() => {
                setCopyIcon("check");
                setTimeout(() => {
                    setCopyIcon("content_copy");
                }, 2000);
            })
            .catch(err => {
                console.error("Failed to copy code text: ", err);
            });
    };

    return (
        <button className="material-symbols-outlined text-[1.25rem]" onClick={handleCopy}>
            {copyIcon}
        </button>
    );
};

export default CodeCopyButton;
